import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from "../../../../app/src/constants/BIDashboardConstants.js";

const RemoveIcon = ((props) => {
    return (
        <svg width="40" height="64" viewBox="0 0 40 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="24.5" width="39" height="39" fill={`${COLORS.biDashboard.raspberry}`}/>
        <path d="M21.4851 44.0002L25.9723 39.5131L26.8976 38.5877C27.0341 38.4512 27.0341 38.2294 26.8976 38.0929L25.9075 37.1028C25.771 36.9663 25.5492 36.9663 25.4127 37.1028L20.0002 42.5153L14.5877 37.1024C14.4512 36.9659 14.2294 36.9659 14.0929 37.1024L13.1024 38.0925C12.9659 38.229 12.9659 38.4508 13.1024 38.5873L18.5153 44.0002L13.1024 49.4127C12.9659 49.5492 12.9659 49.771 13.1024 49.9075L14.0925 50.8976C14.229 51.0341 14.4508 51.0341 14.5873 50.8976L20.0002 45.4851L24.4874 49.9723L25.4127 50.8976C25.5492 51.0341 25.771 51.0341 25.9075 50.8976L26.8976 49.9075C27.0341 49.771 27.0341 49.5492 26.8976 49.4127L21.4851 44.0002Z" fill="white"/>
        </svg>
    )
})

RemoveIcon.props = {
    onClick: PropTypes.func,
}

RemoveIcon.defaultProps = {
    onClick: () => { },
}

export default RemoveIcon;